const hostname = window.location.hostname
const isLocal =
  hostname.endsWith('.local') ||
  hostname.endsWith('.internal') ||
  hostname.includes('localhost') ||
  hostname.includes('192.168.') ||
  hostname.includes('10.0.')
const isDev = !isLocal && (hostname.includes('bejusto.com') || process.env.REACT_APP_DOMAIN)
const isProduction = !isDev && (hostname.includes('.com') || hostname.includes('.io'))

const forceProd = !!process.env.REACT_APP_FORCE_PRODUCTION

export default () => (!isLocal && (isProduction || forceProd) ? 'prod' : isDev ? 'dev' : 'local')
